// extracted by mini-css-extract-plugin
module.exports = {"sidebarDynamicContainer":"SidebarDynamic_sidebarDynamicContainer__7e8Wb","sidebarDynamicChildrenLink":"SidebarDynamic_sidebarDynamicChildrenLink__ngcZd"};